import SolutionCard from "../../reusables/SolutionCard";
import web from "../../../assets/images/solutions-icon/web.svg";

const WebsiteSolution = () => {
  return (
    <SolutionCard
      icon={web}
      title="Website Design & Development"
      subtitle="Modern and responsive websites built for performance and scalability"
      ctaLink="/solutions/website-design-development"
    />
  );
};

export default WebsiteSolution;
